/**
 * This component will show product details, if any, that the sender will pay.
 */
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import enRTRStrings from '../../../../config/enRTRStrings'
import content from 'pp-react-l10n'
import { formatAmount } from '../utils/currencyUtils'
import ProductDetailLine from './product-detail-line'
import { BodyText } from '@paypalcorp/pp-react'
import { hasMultiItemCartShops } from '../../experiments/shops'
import { SHIPPING_TYPES } from '../../../../lib/constants'

let i18n = content('transfer/inc/rtr')

class ProductDetails extends Component {
  static propTypes = {
    showENSubTextRTR: PropTypes.bool,
    stylesFromReviewPage: PropTypes.object,
    shipping: PropTypes.object,
    productDetails: PropTypes.array,
    isDw2Repaint: PropTypes.bool,
    ReviewInfoDiv: PropTypes.func,
    showShipping: PropTypes.bool,
  }

  render() {
    const {
      showENSubTextRTR,
      stylesFromReviewPage,
      productDetails = [],
      shipping = {},
      isDw2Repaint = false,
      ReviewInfoDiv,
      showShipping = false,
    } = this.props

    return (
      <>
        {hasMultiItemCartShops() && productDetails.length > 0 && (
          <Fragment>
            <BodyText strong>{i18n('rtr.orderSummary')}</BodyText>
          </Fragment>
        )}

        {productDetails.map(product => (
          <Fragment key={product.productId}>
            {hasMultiItemCartShops() ? (
              <ProductDetailLine
                showENSubTextRTR={false}
                styles={stylesFromReviewPage}
                firstText={product.productTitle + ' X ' + product.quantity}
                isDw2Repaint={isDw2Repaint}
                ReviewInfoDiv={ReviewInfoDiv}
              />
            ) : (
              <ProductDetailLine
                showENSubTextRTR={false}
                styles={stylesFromReviewPage}
                firstText={product.productTitle}
                secondText={formatAmount(
                  product.productPrice,
                  product.currencyCode
                )}
                isDw2Repaint={isDw2Repaint}
                ReviewInfoDiv={ReviewInfoDiv}
              />
            )}
          </Fragment>
        ))}

        {shipping.shippingFee && showShipping && (
          <ProductDetailLine
            showENSubTextRTR={showENSubTextRTR}
            styles={stylesFromReviewPage}
            firstText={i18n('rtr.shipping')}
            enSubText={enRTRStrings['rtr.shipping']}
            secondText={formatAmount(
              shipping.shippingFee,
              shipping.currencyCode
            )}
            isDw2Repaint={isDw2Repaint}
            ReviewInfoDiv={ReviewInfoDiv}
          />
        )}
      </>
    )
  }
}

export default connect(({ transaction }) => ({
  productDetails: transaction.items.map(item => ({
    productId: item.id,
    productTitle: item.name,
    productPrice: item.totalPrice.value,
    currencyCode: item.totalPrice.currencyCode,
    quantity: item.quantity,
  })),
  shipping: transaction.shippingDetails,
  showShipping:
    transaction.shippingType === SHIPPING_TYPES.FLAT_RATE ||
    transaction.shippingType === SHIPPING_TYPES.FREE,
}))(ProductDetails)
